// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pj-5";
export var filledCircle = "_pj-4";
export var historyEntry = "_pj-3";
export var messageSideLeft = "_pj-1";
export var messageSideRight = "_pj-2";
export var orderTrackingCarouselWrapper = "_pj-6";
export var orderTrackingInfoContainer = "_pj-0";